/**
 * The kinds of receiver the notification service accepts.
 *
 * The two values select both the identifier format and the delivery channel:
 * `Email` carries an email address, `Web` carries an identity reference
 * (`idn-<uuid>`). The service validates the identifier against the type and
 * rejects a mismatch.
 */
export const NotificationReceiverType = {
  Email: 'email',
  Web: 'web',
} as const;

/**
 * A receiver type accepted by `NotificationSettingsService`.
 */
export type NotificationReceiverTypeValue =
  (typeof NotificationReceiverType)[keyof typeof NotificationReceiverType];
